import { useTheme } from '@app/styled';
import { Flex, Popover, WarningIcon } from '@lokalise/louis';
import { PopoverText } from '../../StyleGuideRow/style';
import { IconContainer, SyncButtonContainer, TextContainer } from '../styles';

export const TokenLimitExceededWarningStateButton = () => {
    const theme = useTheme();

    return (
        <Popover
            content={
                <PopoverText>
                    Sync has been delayed as rate limit was reached, we will retry sync automatically. If the issue
                    persists in 5 minutes, try to upload the file again or contact our support to resolve the issue.
                </PopoverText>
            }
            triggerEvent="hover"
            withArrow
        >
            <SyncButtonContainer $hasError $disableCursor>
                <Flex align="center" wrap="nowrap">
                    <IconContainer align="center" justify="center">
                        <WarningIcon color={theme.color.text.warning} size="16px" />
                    </IconContainer>
                    <TextContainer>Sync delayed</TextContainer>
                </Flex>
            </SyncButtonContainer>
        </Popover>
    );
};

export default TokenLimitExceededWarningStateButton;
